/**
 * Règles d'un nouveau mot de passe — identiques à schema-based-tenant-management (PasswordPolicy) :
 * 10 à 128 caractères, au moins une lettre et un chiffre, sans la partie locale de l'email.
 * Renvoie le code du backend (traduit dans i18n "password_change".errors), ou null.
 */
export const PASSWORD_MIN_LENGTH = 10;
export const PASSWORD_MAX_LENGTH = 128;

export const passwordViolation = (candidate, email) => {
    const value = candidate || "";
    if (value.length < PASSWORD_MIN_LENGTH) return "PASSWORD_TOO_SHORT";
    if (value.length > PASSWORD_MAX_LENGTH) return "PASSWORD_TOO_LONG";
    if (!/\p{L}/u.test(value) || !/\p{Nd}/u.test(value)) return "PASSWORD_TOO_SIMPLE";
    const local = (email || "").split("@")[0].toLowerCase();
    if (local.length >= 3 && value.toLowerCase().includes(local)) return "PASSWORD_CONTAINS_EMAIL";
    return null;
};

export const CHANGE_PASSWORD_PATH = "/change-password";
